export default "__VITE_ASSET__CBqbmbWv__"